if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        
        this.spinner = null;

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification, cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        this.setLoadingState(opener, true);

        const productUrl = opener.getAttribute('data-product-url');
        
        fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const productElement = this.parseProductElement(responseText);
            if (!productElement) return;

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            this.initializeShopifyComponents();
            super.show(opener);
          })
          .catch((error) => {
            console.error('Quick add modal error:', error);
          })
          .finally(() => {
            this.setLoadingState(opener, false);
          });
      }

      setLoadingState(opener, isLoading) {
        if (!this.spinner) {
          this.spinner = opener.querySelector('.loading__spinner');
        }

        opener.toggleAttribute('aria-disabled', isLoading);
        opener.classList.toggle('loading', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);
      }

      parseProductElement(responseText) {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        return responseHTML.querySelector('product-info');
      }

      initializeShopifyComponents() {
        if (window.Shopify?.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }
      }

      preprocessHTML(productElement) {
        const colorClasses = Array.from(productElement.classList)
          .filter(cls => cls.startsWith('color-') || cls === 'gradient');
        
        this.modalContent.classList.add(...colorClasses);

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const selectorsToRemove = [
          'pickup-availability',
          'product-modal',
          'modal-dialog'
        ];

        selectorsToRemove.forEach(selector => {
          productElement.querySelectorAll(selector).forEach(el => el.remove());
        });
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, newId);

        Array.from(productElement.attributes).forEach((attr) => {
          if (attr.value.includes(sectionId)) {
            productElement.setAttribute(attr.name, attr.value.replaceAll(sectionId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]')
          .forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        if (!product?.classList.contains('product--columns')) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        const sizeMap = {
          'product--small': '495px',
          'product--medium': '605px',
          'default': '715px'
        };

        const size = Object.keys(sizeMap).find(cls => 
          cls !== 'default' && product.classList.contains(cls)
        ) || 'default';

        const mediaImageSizes = 
          `(min-width: 1000px) ${sizeMap[size]}, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)`;

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}